export enum LeadEmailFormViewStoreEvent {
  submit = 'submit',
  close = 'close',
}
